// 한국어 (ko)

export const ko = {
  brand: { name: 'DoneLine', tagline: '개인 프로젝트 관리 도구' },
  common: {
    save: '저장',
    cancel: '취소',
    confirm: '확인',
    delete: '삭제',
    rename: '이름 변경',
    archive: '보관',
    add: '추가',
    close: '닫기',
    edit: '편집',
    new: '새로 만들기',
    yes: '예',
    no: '아니오',
    back: '뒤로',
    next: '다음',
    skip: '건너뛰기',
    done: '완료',
    loading: '로딩 중…',
    sending: '전송 중…',
    saving: '저장 중…',
    untitled: '제목 없음',
    today: '오늘',
    tomorrow: '내일',
    yesterday: '어제',
    none: '없음',
    optional: '선택',
    requiredField: '필수',
    confirmDelete: '삭제하시겠습니까?',
  },
  nav: {
    today: '오늘',
    upcoming: '예정',
    inbox: '받은편지함',
    projects: '내 프로젝트',
    tags: '태그',
    reports: '주간 리포트',
    settings: '설정',
    quickCapture: '빠른 추가',
    search: '검색',
    newProject: '새 프로젝트',
    addSection: '섹션 추가',
    menu: '메뉴',
    openMenu: '메뉴 열기',
  },
  search: {
    title: '검색',
    placeholder: '작업·프로젝트·태그 검색…',
    noResults: '결과 없음',
    tasks: '작업',
    projects: '프로젝트',
    tags: '태그',
  },
  today: {
    title: '오늘',
    eyebrow: '오늘',
    overdue: '기한 초과',
    today: '오늘',
    completed: '완료',
    empty: '오늘 일정이 없습니다. 잠시 쉬어가세요 ☕',
    summary: '{active} 진행 · {done} 완료',
    reschedule: '일정 변경',
    rescheduled: '{count}개 일정 변경됨',
  },
  inbox: {
    title: '받은편지함',
    eyebrow: '받은편지함',
    empty: '받은편지함이 비어 있습니다.',
    pending: '{count} 처리 대기',
  },
  upcoming: {
    title: '예정',
    eyebrow: '향후 7일',
    todayLabel: '오늘',
    tomorrowLabel: '내일',
    empty: '향후 7일 동안 작업이 없습니다.',
  },
  project: {
    eyebrow: '프로젝트',
    notFound: '프로젝트를 찾을 수 없습니다',
    notFoundHint: '삭제되었거나 보관된 것 같습니다.',
    inProgress: '{count} 진행 중',
    completed: '{count} 완료',
    ungrouped: '미분류',
    addSection: '섹션 추가',
    listView: '목록',
    ganttView: '간트 차트',
    ganttZoomIn: '확대',
    ganttZoomOut: '축소',
    ganttWide: '와이드',
    ganttCompact: '기본 너비',
    empty: '아직 작업이 없습니다',
    emptyHint: '위 입력란에서 추가해 보세요.',
    sectionEmpty: '— 작업 없음 —',
    completedSection: '완료',
    newSectionTitle: '새 섹션',
    newSectionPlaceholder: '섹션 이름',
    renameProjectTitle: '프로젝트 이름 변경',
    renameProjectPlaceholder: '프로젝트 이름',
    editProjectTitle: '프로젝트 편집',
    color: '색상',
    icon: '아이콘',
    noIcon: '아이콘 없음',
    deleteProjectTitle: '프로젝트 "{name}" 삭제?',
    deleteProjectDesc: '이 프로젝트의 작업은 받은편지함으로 이동됩니다. 되돌릴 수 없습니다.',
    archiveProject: '보관',
    actionsMenu: '프로젝트 작업',
    renameSectionTitle: '섹션 이름 변경',
    sectionDeleteTitle: '"{name}" 섹션을 삭제할까요?',
    sectionDeleteDesc:
      '이 섹션의 작업은 프로젝트 최상위로 이동합니다. 이 작업은 되돌릴 수 없습니다.',
    sectionActionsMenu: '섹션 작업',
    sectionReorder: '섹션 순서 변경',
    descriptionPlaceholder: '이 프로젝트에 대한 메모를 입력…',
    descriptionEditHint: 'Markdown 지원 · ⌘↵ 저장 · Esc 닫기',
    descriptionEmpty: '클릭하여 메모 추가',
  },
  upgrade: {
    title: 'DoneLine Pro로 업그레이드',
    featureLocked: '"{feature}"은(는) Pro 기능입니다.',
    comingSoon: 'Pro는 곧 출시됩니다. 그때 계정이 자동으로 준비됩니다.',
    signInFirst: '로그인 후 업그레이드',
    benefits: {
      unlimitedProjects: '프로젝트 무제한 (무료는 최대 3개)',
      history: '365일 수정 이력 (무료는 7일)',
      gantt: '간트 차트 보기',
      importExport: '데이터 가져오기 / 내보내기',
      themes: 'Paper를 포함한 추가 테마',
    },
    feature: {
      projects: '4개 이상 프로젝트',
      gantt: '간트 차트',
      importExport: '가져오기 / 내보내기',
      paperTheme: 'Pro 테마',
    },
    cta: {
      stripe: '구독 — 월 $2.99 / 연 $29.99',
      apple: 'Apple로 구독',
      google: 'Google Play로 구독',
    },
  },
  plan: {
    title: '플랜',
    description: '구독 등급.',
    free: '무료',
    pro: 'Pro',
    proAi: 'Pro AI',
    upgradeButton: 'Pro로 업그레이드',
    devSwitchHint: '미리보기: 플랜을 임시로 전환해 동작을 확인',
    switchToFree: '무료로 전환 (미리보기)',
    switchToPro: 'Pro로 전환 (미리보기)',
  },
  reports: {
    eyebrow: '주간 리포트',
    title: '지난 7일 회고',
    serverGeneratedAt: '서버 생성 시간: {time}',
    syncingFromServer: '서버와 동기화 중…',
    computedLocally: '로컬 계산',
    aiSummary: 'AI 주간 요약',
    completedCount: '완료 수',
    completionRate: '완료율',
    overdueCount: '기한 초과',
    dailyAverage: '일평균',
    dailyCompleted: '일별 완료 수',
    dailyCompletedAxis: '(작업 수)',
    byProject: '프로젝트별',
    noCompletedThisWeek: '이번 주에 아직 완료한 작업이 없습니다.',
    serverNotReady:
      '서버가 이번 주 리포트를 아직 생성하지 않았습니다. 매주 월요일 오전 9시(귀하의 시간대)에 batch worker가 자동 생성합니다.',
  },
  settings: {
    display: {
      title: '표시',
      description: '작업 목록에 표시할 항목을 선택하세요.',
      tags: '태그',
      tagsHint: '작업 행에 태그 표시',
      descriptionLabel: '설명',
      descriptionHint: '설명 한 줄 미리보기 표시',
      subtasks: '하위 작업',
      subtasksHint: '하위 작업 진행률과 펼치기 표시',
    },
    eyebrow: '설정',
    title: '환경 설정',
    appearance: { title: '외관', description: '상황에 맞는 테마를 선택하세요.' },
    language: { title: '언어', description: '메뉴와 라벨에 표시할 언어.' },
    desktop: {
      title: '데스크톱',
      description: '네이티브 macOS / Windows / Linux 동작. 데스크톱 앱에서만 적용됩니다.',
      alwaysOnTopLabel: '항상 위에',
      alwaysOnTopHint: '끄기 전까지 다른 모든 앱 위에 창을 고정합니다.',
      globalHotkeyLabel: '전역 빠른 추가 단축키',
      globalHotkeyHint: '시스템 전역 ⌘⇧Space — 어디에서든 DoneLine을 띄워 입력란에 포커스합니다.',
    },
    account: {
      title: '계정',
      description: '로그인 정보 및 통계.',
      summary: '작업 {tasks}개 · 프로젝트 {projects}개',
      signOut: '로그아웃',
      deleteAccount: '계정 삭제',
      deleteAccountConfirmTitle: '계정을 삭제할까요?',
      deleteAccountConfirmBody:
        '계정과 서버 및 이 브라우저의 모든 작업, 프로젝트, 태그가 영구적으로 삭제됩니다. 되돌릴 수 없습니다. 데이터를 보관하려면 먼저 내보내세요.',
      deleteAccountConfirm: '삭제',
      deleteAccountFailed: '계정을 삭제하지 못했습니다',
      signingOut: '로그아웃 중…',
      notSignedIn: '로그인하지 않음',
      signInCta: '로그인',
      guestHint:
        '게스트 모드: 데이터는 이 기기에만 저장됩니다. 로그인하면 동기화와 백업이 활성화됩니다.',
      displayNameLabel: '표시 이름',
      displayNamePlaceholder: '이름',
      displayNameSaved: '저장됨',
      displayNameSaveFailed: '저장 실패',
      avatarLabel: '아바타',
      avatarHint: 'JPG / PNG / WEBP / GIF, 최대 2 MB. 비워두면 이니셜이 표시됩니다.',
      avatarUpload: '사진 업로드',
      avatarChange: '사진 변경',
      avatarUploading: '업로드 중…',
      avatarRemove: '제거',
      avatarSaved: '아바타가 업데이트되었습니다',
      avatarSaveFailed: '아바타 업데이트 실패',
      avatarErrorType: '지원하지 않는 이미지 형식입니다. JPG / PNG / WEBP / GIF만 가능합니다.',
      avatarErrorSize: '이미지가 너무 큽니다. 최대 2 MB.',
    },
    sync: {
      title: '동기화',
      description: '서버와 전체 증분 동기화를 즉시 실행.',
      forceSync: '지금 강제 동기화',
      syncing: '동기화 중…',
      done: '동기화 완료',
    },
    shortcuts: {
      title: '키보드 단축키',
      description: '키보드는 가장 빠른 포인터입니다.',
      view: '단축키 보기',
    },
    data: {
      title: '데이터',
      description: '모든 데이터는 우선 로컬에 저장된 뒤 서버로 동기화됩니다.',
      export: 'JSON 내보내기',
      import: 'JSON 가져오기',
      exportDone: '{n}개 작업 내보냈습니다',
      importDone: '신규 {n}개 가져왔습니다',
      importError: '가져오기 실패: {error}',
      importPersistFailed:
        '가져온 데이터를 로컬 저장소에 저장하지 못했습니다. 기기 저장 용량 한도를 초과했을 수 있으니 여러 번에 나누어 가져오세요.',
      clearAll: '로컬 데이터 삭제',
      clearConfirmTitle: '모든 로컬 데이터를 삭제하시겠습니까?',
      clearConfirmDesc:
        '이 브라우저에 저장된 모든 내용이 제거됩니다. 서버에 동기화된 데이터는 영향받지 않습니다. 완료 후 페이지가 새로고침됩니다.',
      cleared: '삭제 완료. 새로고침 중…',
    },
    about: {
      title: '정보',
      version: '버전 {v}',
      description: 'GTD 기반의 개인 할 일 & 프로젝트 관리 도구.',
    },
  },
  guest: {
    banner: '게스트 모드 — 데이터는 이 기기에만 저장됩니다. 로그인하면 여러 기기에서 동기화됩니다.',
    bannerCta: '로그인',
    emptyHint: '로그인 전에는 데이터가 이 기기에만 저장됩니다. 아래에서 첫 작업을 추가해 보세요.',
    storageWarning:
      '게스트 데이터는 이 브라우저에만 저장되며 시스템에 의해 삭제될 수 있습니다. 로그인하거나 정기적으로 내보내기 하세요(내보내기 파일은 암호화되지 않음).',
  },
  login: {
    welcomeBack: '다시 오신 것을 환영합니다',
    helperSupabase: '이메일을 입력하시면 일회용 로그인 링크를 보내드립니다.',
    helperLocal: '로컬 모드: 이메일을 입력하면 바로 로그인됩니다 (Supabase 미구성 시 fallback).',
    emailPlaceholder: 'you@example.com',
    sendLink: '로그인 링크 보내기',
    sendingLink: '전송 중…',
    sentSupabase: '{email}로 전송했습니다. 메일의 링크를 클릭하세요.',
    otpPrompt: '또는 이메일의 인증 코드 입력',
    otpPlaceholder: '6자리 코드',
    otpSubmit: '로그인',
    otpFailed: '코드가 유효하지 않거나 만료되었습니다',
    sentLocal: '{email}로 로그인되었습니다. 진입 중…',
    modeSupabase: 'Supabase Auth',
    modeLocal: '로컬 Mock 모드 (백엔드 미구성)',
    skipGuest: '건너뛰고 바로 사용',
    skipFailed: '게스트 모드를 시작할 수 없습니다(로컬 저장 실패). 다시 시도해 주세요.',
    merge: {
      title: '이 기기에 {count}개의 작업이 있습니다',
      keep: '내 계정으로 병합',
      irreversible: '로그인 후 계정으로 업로드됩니다. 병합은 되돌릴 수 없습니다.',
      discard: '로컬 데이터를 유지하지 않고 로그인',
      discardConfirmTitle: '로그인 후 로컬 작업 {count}개가 삭제됩니다',
      discardConfirmBody:
        '로그인이 완료되면 이 기기의 작업 {count}개가 영구 삭제되며 복구할 수 없습니다. 계속할까요?',
    },
    error: '로그인 실패',
  },
  task: {
    recurringAdvanced: '반복 작업이 {date}(으)로 이동했습니다',
    recurringFinished: '반복이 끝나 작업을 완료했습니다',
    titlePlaceholder: '작업 제목',
    description: '설명',
    descriptionPlaceholder: '설명 추가…',
    descriptionEmpty: '설명이 없습니다.',
    descriptionEdit: '설명 편집',
    descriptionSave: '설명 저장',
    descriptionCancel: '취소',
    save: '저장',
    saved: '저장됨',
    discardConfirmTitle: '저장하지 않은 변경을 버리시겠습니까?',
    discardConfirmDesc: '저장하지 않은 편집이 있습니다. 지금 닫으면 사라집니다.',
    priority: '우선순위',
    date: '날짜',
    project: '프로젝트',
    section: '섹션',
    parentTask: '상위 작업',
    tags: '태그',
    subtasks: '하위 작업',
    expandSubtasks: '하위 작업 펼치기',
    collapseSubtasks: '하위 작업 접기',
    addSubtaskPlaceholder: '+ 하위 작업 추가',
    comments: '댓글',
    noComments: '아직 댓글이 없습니다',
    commentPlaceholder: '댓글 작성…',
    sendComment: '전송',
    delete: '삭제',
    deleteConfirmTitle: '이 작업을 삭제하시겠습니까?',
    deleteConfirmDesc: '하위 작업도 함께 삭제됩니다.',
    saveHint: '⌘/Ctrl + Enter로 저장 후 닫기',
    open: '열기',
    completed: '완료',
    markComplete: '완료로 표시',
    markIncomplete: '미완료로 표시',
    moreActions: '더보기',
  },
  priority: {
    high: '높음',
    mid: '보통',
    low: '낮음',
    none: '없음',
    p1: 'P1',
    p2: 'P2',
    p3: 'P3',
    p4: 'P4',
  },
  date: {
    picker: {
      single: '단일 날짜',
      datetime: '시각',
      range: '기간',
      today: '오늘',
      tomorrow: '내일',
      thisWeekend: '이번 주말',
      nextWeek: '다음 주',
      noDate: '날짜 없음',
    },
    overdue: '기한 초과',
    notScheduled: '날짜 미설정',
  },
  recurrence: {
    title: '반복',
    none: '반복 안 함',
    custom: '사용자 지정…',
    applyCustom: '사용자 지정 규칙 적용',
    end: '반복 종료',
    preset: {
      daily: '매일',
      weekdays: '평일',
      weekly: '매주',
      biweekly: '2주마다',
      monthly: '매월',
      yearly: '매년',
    },
    summary: {
      daily: '매일',
      everyNDays: '{n}일마다',
      weekly: '매주',
      everyNWeeks: '{n}주마다',
      weeklyOn: '매주 {days}',
      everyNWeeksOn: '{n}주마다 {days}',
      monthly: '매월',
      everyNMonths: '{n}개월마다',
      yearly: '매년',
      everyNYears: '{n}년마다',
    },
    weekday: { sun: '일', mon: '월', tue: '화', wed: '수', thu: '목', fri: '금', sat: '토' },
    // ko 도 "N일마다" 어순. "마다"는 후치 조사라서 영어의 Every→N→Unit 레이아웃에 맞추려면
    // every 를 비우고 freq 단위에 "마다"를 붙인다.
    freq: { daily: '일마다', weekly: '주마다', monthly: '개월마다', yearly: '년마다' },
    every: '',
  },
  aiUsage: {
    title: 'AI 사용량',
    planFree: '무료 플랜',
    planPro: 'Pro 플랜',
    planProAi: 'Pro AI 플랜',
    usedOf: '이번 달 {used} / {limit}회',
    remaining: '남은 횟수: {count}회',
    resetsMonthly: '매월 1일(UTC) 초기화',
    history: '최근 사용',
    historyEmpty: '아직 사용 기록이 없습니다',
    endpointParse: 'AI 해석',
    endpointBreakdown: 'AI 분해',
    signInFirst: '로그인하면 확인할 수 있습니다',
    loadFailed: '불러오지 못했습니다',
    retry: '다시 시도',
  },
  parseTask: {
    mode: 'AI',
    quickMode: '빠른 입력',
    title: 'AI 작업 분석',
    placeholder: '작업을 자유롭게 입력하세요…',
    titlePlaceholder: '작업 제목',
    hint: 'AI가 날짜, 우선순위, 프로젝트, 태그를 자동 입력',
    parse: '분석',
    confirm: '작업 추가',
    confirmMany: '작업 {count}개 추가',
    back: '뒤로',
    voice: '음성 입력',
    voiceDenied: '마이크 권한이 거부되었습니다',
    voiceUnavailable: '이 브라우저는 음성 입력을 지원하지 않습니다',
    errors: {
      rateLimited: '요청이 너무 많습니다. 잠시 후 다시 시도하세요',
      monthlyLimit: '이번 달 AI 사용량을 모두 사용했습니다. 업그레이드로 더 이용하세요',
      unauthorized: 'AI를 사용하려면 로그인하세요',
      unavailable: 'AI를 현재 사용할 수 없습니다',
      failed: '작업을 분석할 수 없습니다. 다르게 표현해 보세요',
    },
  },
  quickCapture: {
    placeholder: '작업 추가… (Enter로 저장)',
    hint: '예: "장보기 tomorrow @생활 #빠른 p2"',
    newTag: '#{name} (새 태그)',
    dismissMatch: '"{label}"을(를) 텍스트로 유지',
    createTag: '태그 "{name}" 만들기',
    syntaxCheatsheet: 'today / tomorrow / next mon · @프로젝트[/섹션] · #태그 · p1-p4',
    add: '추가',
    open: '빠른 추가 열기',
    addTask: '작업 추가',
  },
  tag: {
    eyebrow: '태그',
    editTagTitle: '태그 편집',
    renameTagPlaceholder: '태그 이름',
    newTagPlaceholder: '새 태그…',
    deleteTagTitle: '태그 "{name}"을(를) 삭제할까요?',
    deleteTagDesc: '{count}개의 작업에서 이 태그가 제거됩니다. 되돌릴 수 없습니다.',
    actionsMenu: '태그 작업',
    nameTaken: '같은 이름의 태그가 이미 있습니다',
    empty: '이 태그가 붙은 작업이 없습니다',
  },
  quickbar: {
    signInRequired: '로그인이 필요합니다',
    signInHint: '메뉴 바에서 작업을 추가하려면 먼저 로그인하세요.',
    signInOpenMain: 'DoneLine 메인 창을 열어 로그인하세요',
  },
  sync: {
    idle: '동기화됨',
    syncing: '동기화 중',
    offline: '오프라인',
    error: '동기화 실패',
    disabled: '로컬 모드',
    pending: '{count} 대기',
    syncingPending: '동기화 중 · {count} 대기',
    offlinePending: '오프라인 · {count} 대기',
    authError: '인증 실패 — 다시 로그인해 주세요',
    rejectedBatch: 'Data validation failed — some changes were dropped',
    retry: '클릭하여 다시 시도',
  },
  commandPalette: {
    placeholder: '작업 검색, 뷰 이동, 명령 실행…',
    empty: '일치하는 항목이 없습니다.',
    tasks: '작업',
    projects: '프로젝트',
    navigation: '탐색',
    actions: '동작',
  },
  bulk: {
    toolbar: '일괄 작업',
    selected: '{count}개 선택됨',
    clear: '선택 해제',
    deleteTitle: '선택한 {count}개 작업을 삭제하시겠습니까?',
    deleteDesc: '하위 작업도 함께 삭제됩니다. 되돌릴 수 없습니다.',
    mixedProjects: '여러 프로젝트',
  },
  shortcuts: {
    title: '키보드 단축키',
    quickAdd: '빠른 추가',
    search: '검색',
    help: '이 패널 보기',
    gotoToday: '오늘로 이동',
    gotoInbox: '받은편지함으로',
    gotoUpcoming: '예정으로',
    drawer: {
      title: '작업 상세 내',
      saveClose: '저장 후 닫기',
      delete: '작업 삭제',
      priorityKeys: '우선순위 설정 (1=높음 … 4=없음)',
    },
  },
  welcome: {
    title: '{brand}에 오신 것을 환영합니다',
    subtitle: '30초 만에 시작합시다.',
    step1: {
      title: '1초 만에 무엇이든 캡처',
      body: '아무 페이지에서 Q를 누르면 빠른 추가가 열립니다. 작업을 입력하고 Enter를 누르면 받은편지함에 바로 들어갑니다.',
    },
    step2: {
      title: '여유 있을 때 정리',
      body: '작업을 프로젝트와 섹션으로 드래그. 날짜·우선순위·태그는 나중에 추가하면 됩니다.',
    },
    step3: {
      title: '오늘을 계획',
      body: '오늘 보기는 오늘 마감 작업과 오늘이 포함된 기간 작업을 자동으로 모아줍니다.',
    },
    step4: {
      title: '준비 완료',
      body: '익숙해지도록 시작 작업을 몇 개 추가했습니다. 완료해도 삭제해도 좋습니다.',
    },
    getStarted: '시작하기',
  },
  onboarding: {
    project: { welcome: '환영', learn: '학습' },
    tasks: {
      welcome: '👋 {brand}에 오신 것을 환영합니다!',
      welcomeDesc: '왼쪽 체크박스를 클릭해 완료로 표시하세요. 이것이 작업을 완료하는 방법입니다.',
      quickAdd: '⚡ 빠른 추가 시도: Q 키 또는 좌측 상단 버튼',
      quickAddDesc:
        '작업 제목을 입력하고 Enter. @프로젝트로 분류, #태그로 라벨, p1-p4로 우선순위 지정.',
      organize: '📁 관련 작업을 프로젝트로 묶기',
      organizeDesc: '왼쪽에서 "+ 새 프로젝트" 클릭. 작업을 드래그해 정리.',
      schedule: '🗓 날짜를 설정해 계획',
      scheduleDesc:
        '오늘 일정 작업은 자동으로 "오늘" 보기에 나타납니다. 이 작업을 열어 마감일을 설정해보세요.',
      priority: '🔥 우선순위 활용 (P1 높음 … P4 없음)',
      priorityDesc: '작업 상세에서 1 / 2 / 3 / 4 를 누르면 우선순위 빠른 전환.',
      drag: '✋ 드래그로 순서 변경',
      dragDesc: '작업 위에 마우스를 올리면 왼쪽에 핸들이 나타납니다. 잡고 원하는 위치로.',
      gantt: '📊 간트 차트로 시각화',
      ganttDesc: '프로젝트를 열어 "간트" 탭으로 전환하면 시간축에서 작업을 볼 수 있습니다.',
      reports: '📈 주간 리포트로 회고',
      reportsDesc: '매주 무엇을 완료했고 무엇이 미뤄졌는지 확인하세요.',
      finishMe: '✅ 이 체크리스트 완료 — 이제 준비됐어요!',
    },
  },
  errors: {
    networkError: '네트워크 오류',
    unknownError: '알 수 없는 오류',
    notFound: '찾을 수 없음',
    pageNotFound: '페이지를 찾을 수 없습니다',
    pageNotFoundDesc: '이 URL은 존재하지 않거나 이동되었습니다.',
    backHome: '오늘로 돌아가기',
    somethingWrong: '문제가 발생했습니다',
    tryAgain: '다시 시도',
    goHome: '홈으로',
  },
  theme: {
    light: '라이트',
    dark: '다크',
    paper: '종이',
    rose: '로즈',
    lavender: '라벤더',
    peach: '피치',
    mauve: '모브',
    slate: '슬레이트',
    forest: '포레스트',
    midnight: '미드나이트',
    shiba: '시바',
    cat: '고양이',
    ocean: '오션',
    sky: '스카이',
    mint: '민트',
    matcha: '말차',
    amber: '앰버',
    mocha: '모카',
    crimson: '크림슨',
    nord: '노르드',
    dracula: '드라큘라',
    graphite: '그래파이트',
    system: '시스템',
    pickerTitle: '테마',
  },
} as const;
